function ScreenTip(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="29"
      fill="none"
      viewBox="0 0 70 29"
      {...props}
    >
      <path
        fill="var(--syntax-bg)"
        d="M35 1C25.5 1 20.615 27 1 27v2h68v-2C48.077 27 44.5 1 35 1z"
      />
      <path
        stroke="var(--color-gray-300)"
        strokeLinecap="round"
        strokeWidth="2"
        d="M1 27C20.615 27 25.5 1 35 1s13.077 26 34 26"
      />
    </svg>
  );
}

export default ScreenTip;
